import React from "react";
import { defaultHandleChange } from "../../utils/handler";
import { DEFAULT_CHANGE_PASSWORD_CREDENTIALS } from "../../utils/state";
import { Snackbar } from "../../components/Snackbar";
import { DEFAULT_SNACKBAR } from "../../utils/snackbar";
import { ChangePasswordForm } from "../../components/LoginForm/ChangePasswordForm";
import { useValidToken } from "../../hooks/useValidToken";
import Wrapper from "../../components/LoginForm/Wrapper";
import { useBackground } from "../../hooks/useBackground";
import { fetcher } from "../../utils";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { THEME_SEVERITY } from "../../utils/theme";
import { useTheme } from "../../contexts/ThemeContext";
import { useConfig } from "../../contexts/config";

const ChangePassword = () => {
  const navigate = useNavigate();
  const { lang } = useAuth();
  const [credentials, setCredentials] = React.useState(
    DEFAULT_CHANGE_PASSWORD_CREDENTIALS
  );
  const [loading, setLoading] = React.useState(false);
  const theme = useTheme();
  const { config } = useConfig();
  const [snackbar, setSnackbar] = React.useState(DEFAULT_SNACKBAR);
  const { data, isValid } = useValidToken(window.location.search);
  /*   console.log(data); */
  const URL =
    "https://par.tuclase.cl/tipddy/admin/iapp/services/restore-password.php/user/changepassword";
  const headers = { "Content-Type": "appplication/json" };

  React.useEffect(() => {
    lang && console.log(lang["Recovery"]);
  }, [lang]);

  useBackground();

  const handleSnackbar = (snack) => {
    setSnackbar(snack);
    setTimeout(() => {
      setSnackbar(DEFAULT_SNACKBAR);
    }, 2000);
  };

  const clean = () => {
    setCredentials(DEFAULT_CHANGE_PASSWORD_CREDENTIALS);
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEmpty = Object.values(credentials).some((value) => value === "");
    if (isEmpty) {
      handleSnackbar({
        visible: true,
        message: lang["Snackbars"].invalid_access,
        severity: THEME_SEVERITY.ERROR,
      });
      return;
    }
    if (credentials.password !== credentials.confirm_password) {
      handleSnackbar({
        visible: true,
        message: lang["Snackbars"].invalid_access,
        severity: THEME_SEVERITY.ERROR,
      });
      return;
    }
    try {
      setLoading(true);
      await fetcher(URL, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          password: credentials.password,
          token: data.setdata.token,
        }),
      });
      handleSnackbar({
        visible: true,
        message: lang["Snackbars"].success_change,
        severity: THEME_SEVERITY.SUCCESS,
      });
      clean();
      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (error) {
      console.log(error.message);
      setSnackbar({
        visible: true,
        message: lang["Snackbars"].invalid_access,
        severity: THEME_SEVERITY.ERROR,
      });
      setLoading(false);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
    }
  };

  const handleChange = (e) =>
    defaultHandleChange(e, credentials, setCredentials);

  if (!isValid) {
    return (
      <Wrapper>
        <p className="text-white text-center my-5">Token ya expiró</p>
      </Wrapper>
    );
  }

  return (
    <>
      {lang && (
        <>
          <div className="container esp-log">
            <img
              src="https://par.tuclase.cl/loginalt/images/logo2.png"
              alt="logo"
              className="posi-logo posi-log-b"
            />
          </div>
          <div className="flex laptop:flex-row flex-col gap-[20%] items-center ">
            <div
              style={{ background: theme.colors.secondary_light }}
              className=" flex flex-col w-[90%] tablet:w-[37rem] rounded-xl shadow-lg ml-[5%] tablet:ml-[15%] my-8"
            >
              <div
                style={{ background: theme.colors.primary_light }}
                className="rounded-t-xl h-[19rem] flex flex-col items-center justify-center"
              >
                <img
                  className="logo-login py-8 "
                  src={
                    theme && theme.mode === "light"
                      ? config.config.theme.theme_logo_dark
                      : config.config.theme.theme_logo_dark
                  }
                  alt="..."
                />
              </div>
              <div className="p-8 space-y-8  rounded-lg shadow-md">
                <p className="iniciar-new">{lang["Recovery"].title}</p>
                <ChangePasswordForm
                  handleChange={handleChange}
                  handleSubmit={handleSubmit}
                  credentials={credentials}
                  loading={loading}
                />
              </div>
            </div>
            <div className=" ml-[5%] tablet:ml-[15%] laptop:ml-0">
              <h1 className="llamado text-4xl tablet:text-5xl laptop:text-8xl">
                Ingrese su usuario <br />y su correo.
              </h1>
              <p className="llamado-d text-2xl tablet:text-3xl laptop:text-4xl">
                luego se le enviará un mail a su correo con los pasos a seguir
              </p>
            </div>
          </div>
          <Snackbar
            severity={snackbar.severity}
            visible={snackbar.visible}
            message={snackbar.message}
          />
        </>
      )}
    </>
  );
};
export default ChangePassword;
